import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import PageContainer from "../layout/PageContainer.js";
import { MentalPatternsProvider, useMentalPatterns } from "./MentalPatternsContext.js";

import { behavioralPatternsPath } from "../../constants/routes.js";
import { MENTAL_LOAD_INDEX_ROUTE } from "../../constants/wellness.js";
import { GAD7_ROUTE } from "../../constants/gad7.js";

const HASH_REDIRECTS = {
  "wellness-scale": MENTAL_LOAD_INDEX_ROUTE,
  wellness: MENTAL_LOAD_INDEX_ROUTE,
  "mental-load": MENTAL_LOAD_INDEX_ROUTE,
  "under-stress": behavioralPatternsPath("under-stress"),
  "anger-scale": behavioralPatternsPath("anger"),
  "gad-7": GAD7_ROUTE
};

const MentalPatternsLayoutInner = ({ isSubscriber, verifiedEmail }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isLoading, error, retry } = useMentalPatterns();

  useEffect(() => {
    const hash = location.hash.replace("#", "");
    if (hash && HASH_REDIRECTS[hash]) {
      navigate(HASH_REDIRECTS[hash], { replace: true });
    }
  }, [location.hash, navigate]);

  return (
    <PageContainer>
      {isLoading ? <p>Loading behavioral patterns…</p> : null}
      {error ? (
        <div className="login-error">
          <p>{error}</p>
          <button type="button" className="link-button" onClick={retry}>
            Retry
          </button>
        </div>
      ) : null}
      {!isLoading && !error ? <Outlet context={{ isSubscriber, verifiedEmail }} /> : null}
    </PageContainer>
  );
};

const MentalPatternsLayout = ({ verifiedEmail, isSubscriber }) => (
  <MentalPatternsProvider verifiedEmail={verifiedEmail}>
    <MentalPatternsLayoutInner isSubscriber={isSubscriber} verifiedEmail={verifiedEmail} />
  </MentalPatternsProvider>
);

export default MentalPatternsLayout;
